import state from '../state';

export function addMobileClass(className: string = '') {
  if (state.isMobileViewport) {
    return className + ' is-mobile-viewport';
  }
  return className;
}
